import { useEffect, useState } from "react";
import OpacityContainer from "../../components/elements/OpacityContainer/OpacityContainer";
import MiddleBlock from "../../components/MiddleBlock/MiddleBlock";
import SectionHeader from "../../components/SectionHeader/SectionHeader";
import "./About.css";
import InformationBlock from "./components/InformationBlock/InformationBlock";
import { getContacts } from "../../api/api";
import Loader from "../../components/elements/Loader/Loader";

export default function About() {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadContacts() {
            try {
                const data = await getContacts();
                // Проверяем, что data — это массив
                if (Array.isArray(data)) {
                    setContacts(data);
                    console.log('Контакты загружены:', data);
                } else {
                    console.error('API вернуло не массив:', data);
                    setContacts([]);
                }
            } catch (error) {
                console.log('Ошибка:', error);
                setContacts([]);
            } finally {
                setLoading(false);
            }
        }
        
        loadContacts();
    }, []);

    // Разделяем контакты на "big" (с description) и "small" (без description)
    const bigContacts = contacts.filter(contact => contact.description && contact.description !== '');
    const smallContacts = contacts.filter(contact => !contact.description || contact.description === '');

    if (loading) {
        return <Loader />
    }

    return (
        <div className="about-page">
            <MiddleBlock>
                <div className="about-opacity-containers">
                    <OpacityContainer
                        background={"rgba(236, 225, 207, .49)"}
                        borderColor={"#DCD0BC"}
                        shadowColor={"#DAC7A9"}
                        title="Powstaliśmy z myślą o artystach"
                        description={"Fundacja Artystyczna QUENA powstała z przekonania, że każdy talent zasługuje na szansę, by wybrzmieć. Tworzymy przestrzeń, w której młodzi artyści mogą rozwijać swoje umiejętności, zdobywać doświadczenie i budować swoją drogę zawodową. Łączymy twórców z osobami, które posiadają wiedzę, doświadczenie i kompetencje niezbędne do świadomego funkcjonowania w świecie sztuki. Wspieramy artystów nie tylko w rozwijaniu ich talentu, ale również w promocji twórczości, budowaniu profesjonalnego wizerunku, nawiązywaniu kontaktów oraz zdobywaniu nowych doświadczeń. Wierzymy, że sztuka potrzebuje przestrzeni, w której może swobodnie się rozwijać, a młodzi artyści – ludzi, którzy dostrzegą ich potencjał i pomogą im postawić pierwszy ważny krok."}
                        number={"about_first"}
                    />
                    <OpacityContainer
                        background={"rgba(236, 225, 207, .49)"}
                        borderColor={"#DCD0BC"}
                        shadowColor={"#DAC7A9"}
                        title="QUENA – głos, który warto usłyszeć"
                        description={"Nazwa QUENA nawiązuje do tradycyjnego andyjskiego instrumentu, którego dźwięk od wieków towarzyszy ludziom i opowiada historie. Dla nas Quena jest symbolem indywidualnego głosu artysty. Każdy twórca ma własną historię, własną wrażliwość i własny sposób wyrażania emocji. Naszą rolą jest pomóc mu odnaleźć przestrzeń, w której ten głos będzie mógł wybrzmieć. Wierzymy, że sztuka nie powstaje w oderwaniu od świata. Za każdym artystą stoi wiele osób – mentorów, organizatorów, menedżerów, partnerów i odbiorców. Dlatego budujemy środowisko współpracy, które pozwala talentom rozwijać się w sposób świadomy i profesjonalny."}
                        number={"about_second"}
                    />
                </div>
            </MiddleBlock>

            <SectionHeader>Nasz zespół</SectionHeader>
            <MiddleBlock>
                {/* Большие блоки (с description) */}
                {bigContacts.map(contact => (
                    <InformationBlock 
                        key={contact.id || Math.random()}
                        type="big"
                        id={contact.id}
                        title={contact.title}
                        post={contact.post}
                        description={contact.description}
                        avatar={contact.avatar ?? '/uploads/contacts/o_nas_avatar.png'}
                    />
                ))}
                
                {/* Маленькие блоки (без description) - в ряд */}
                {smallContacts.length > 0 && (
                    <div className="information-blocks-inline">
                        {smallContacts.map(contact => (
                            <InformationBlock 
                                key={contact.id || Math.random()}
                                type="small"
                                id={contact.id}
                                title={contact.title}
                                post={contact.post}
                                avatar={contact.avatar ?? '/uploads/contacts/o_nas_avatar.png'}
                            />
                        ))}
                    </div>
                )}
            </MiddleBlock>
        </div>
    );
}